export default __webpack_public_path__ + "static/media/product-detail-full-04.68794c6e.jpg";